import { TextField } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';

const re = new RegExp(/^((\+614|04)\d{2})\s?(\d{3})\s?(\d{3})$/);

const MobileEntry = props => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [error, setError] = useState(false);
    const [errorCode, setErrorCode] = useState('');
    const curserPos = useRef(phoneNumber.length);
    const inputRef = useRef(null);

    useEffect(() => {
        if (typeof props.phoneNumber !== 'undefined') {
            if (props.phoneNumber !== '') {
                if (re.test(props.phoneNumber)) {
                    const value = props.phoneNumber.replace(re, '$1 $3 $4');
                    setPhoneNumber(value);
                } else {
                    setError(true);
                    setErrorCode('Enter a valid Mobile Number');
                }
            }
            if (props.passThroughError) {
                setError(true);
                setErrorCode('Enter a Mobile Number');
            } else {
                setError(false);
                setErrorCode('');
            }
        }
    }, [props]);

    useEffect(() => {
        if (inputRef === null) return;
        if (inputRef.current === null) return;
        inputRef.current.setSelectionRange(
            curserPos.current,
            curserPos.current
        );
    }, [phoneNumber]);

    function updatePhone(event) {
        const input = event.target.value;
        const start = inputRef.current.selectionStart;
        const deleting = input.length < phoneNumber.length;

        let output = input.replace(/[^\d+]/g, ''); // remove non digits
        output = output.replace(/(?!^)\+/g, ''); //only allow + at beginning

        output = output.replace(/\+614/, '04');
        output = output.replace(/^(\d{4})(\d)/, '$1 $2');
        output = output.replace(/(\s\d{3})(\d)/, '$1 $2');
        output = output.replace(/ $/, '');

        // Length limit
        if (output.length > 12) output = phoneNumber;

        if (!re.test(output)) {
            setError(false);
            setErrorCode('');
        }

        // Curser cannot be at end of space eg '| '
        if (output.slice(start - 1, start) === ' ')
            if (!deleting) curserPos.current = start + 1;
            else curserPos.current = start - 1;
        else curserPos.current = start;
        setPhoneNumber(output);
    }

    function exitPhone(_event) {
        var errorBack = false;
        if (!re.test(phoneNumber)) {
            errorBack = true;
            setError(true);
            setErrorCode('Enter a valid Mobile Number');
        } else {
            setError(false);
            setErrorCode('');
        }
        props.touched(true);
        props.error(errorBack);
        props.value(phoneNumber);
    }

    return (
        <TextField
            disabled={props.disabled}
            inputRef={inputRef}
            error={error}
            id="phone"
            data-cy="phone"
            label={props.label}
            variant={props.variant}
            helperText={errorCode}
            value={phoneNumber}
            onChange={updatePhone}
            onBlur={exitPhone}
            sx={props.sx}
        />
    );
};

export default MobileEntry;
